const InvoicesBanner = () => {
  return (
    <div className="w-full my-4 bg-yellow-100 border border-yellow-300 text-yellow-800 px-4 py-3 rounded-lg flex items-center gap-2 relative">
      Invoices typically appear here on the{" "}
      <strong>5th day of each month.</strong>You can adjust the date filters to
      explore past invoices once they&#39;re available.
    </div>
  );
};

export default InvoicesBanner;
